<template>
  <div>
    <a-select v-model="selectedOption" ref="mySelect" placeholder="请选择" @paste="handlePaste" style="width: 200px;margin-bottom: 20px;">  
      <a-select-option v-for="item in options" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
    </a-select>
    <!-- 上传图片 -->
    <div style="height: 120px;">
      <div>
        <span class="uploadImg">
          <input
              id="inputTest"
              ref="addImg"
              accept="image/*"
              style="width: 100%;height:100%;opacity: 0;margin-right: 14px;"
              type="file"
              @change="uploadImg('addImg')"
              />
        </span>
        <span id="yulan">
          <span class="upload_gutter" v-for="(items,index) in form.images" >
            <div style="height: 120px;width: 120px;position: relative;margin-right: 10px;border: #DDDDDD 2px dashed;">
              <!-- <a-icon type="close" style="color: red;position: absolute;right: 0;" @click="getIndex(index)"/>  -->
              <img :index="index"
                   :src="items"
                   alt=""  
                   style="width: 120px;height: 120px;"
                   @click="openVideoUrl(items)"
              />
            </div>
          </span>
        </span>
      </div>
    </div>
    <br>
    <!-- 上传视频 -->
    <div style="height: 120px;">
      <div style="width: 100%;">
        <!-- 视频预览框 -->
        <span style="float:left;width:100%"> 
          <span class="uploadImgVideo" >
            <input
              :disabled="disabledVideo"
              id="up_video_surface_plot"
              style="width: 120px;height:100%;opacity: 0;float:left"
              type="file" 
              accept=".mp4"
              @change="content_surface_plot_original_video($event)" />
          </span>
          <div>
            <span v-for="(items,index) in form.videos">
              <div
              class="upload_LiveBroadcast">
              <video
                  @click="openVideoUrl(items)"
                  style="width: 120px;height:120px;float:right"
                  :src="items"></video>
              <!-- <a-icon type="close" style="color: red;float: right;transform: translateY(-120px);" @click="getVideoIndex(index)"/>  -->
              </div>
              </span>
          </div>
        </span>
      </div>
      <div v-if="disabledVideo" style="color: #ff0000">视频上传中...</div>
    </div>
    <br>
    <!-- 富文本框 -->
    <div
      v-if="addShow == true"
      style="border: 1px solid #ccc; min-height: 301px; width: 450px"
    >
      <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editor"
        :defaultConfig="toolbarConfig"
        :mode="mode"
      />
      <Editor
        style="height: 300px; overflow-y: hidden"
        v-model="form.introduce"
        :defaultConfig="editorConfig"
        :mode="mode"
        @onCreated="onCreated"
      />
    </div>
    <br>

    <a-table :columns="columns" :data-source="data" bordered>
    <template
      v-for="col in ['name', 'age', 'address']"
      :slot="col"
      slot-scope="text, record, index"
    >
      <div :key="col">
        <a-input
          v-if="record.editable"
          style="margin: -5px 0"
          :value="text"
          @change="e => handleChange(e.target.value, record.key, col)"
        />
        <template v-else>
          {{ text }}
        </template>
      </div>
    </template>
    <template slot="operation" slot-scope="text, record, index">
      <div class="editable-row-operations">
        <span v-if="record.editable">
          <a @click="() => save(record.key)">Save</a>
          <a-popconfirm title="Sure to cancel?" @confirm="() => cancel(record.key)">
            <a>Cancel</a>
          </a-popconfirm>
        </span>
        <span v-else>
          <a :disabled="editingKey !== ''" @click="() => editTable(record.key)">Edit</a>
        </span>
      </div>
    </template>
    </a-table>

    <!-- grid 垂直居中 -->
     grid 水平垂直居中
     <div class="testGrid">
        <div style="width:50px;height: 50px;background-color: pink;">

        </div>
     </div>
  </div>

</template>

<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import TcVod from "vod-js-sdk-v6";
import axios from "axios";

const columns = [
  {
    title: 'name',
    dataIndex: 'name',
    width: '25%',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'age',
    dataIndex: 'age',
    width: '15%',
    scopedSlots: { customRender: 'age' },
  },
  {
    title: 'address',
    dataIndex: 'address',
    width: '40%',
    scopedSlots: { customRender: 'address' },
  },
  {
    title: 'operation',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

// 富文本框
const editorConfig = {
  // JS 语法
  MENU_CONF: {},
};
const signature = "";
// 修改 uploadImage 菜单配置
editorConfig.MENU_CONF["uploadImage"] = {
  // 自定义上传
  async customUpload(file, insertFn) {
    let formData = new FormData();
    formData.append("file", file);
    // file 即选中的文件,自己实现上传，并得到图片 url alt href
    axios
      .post(
        "https://yun-new-admin-api.yunicu.com/api/admin/common/update",
        formData
      )
      .then((res) => {
        if (res.data.code === 0) {
          insertFn(res.data.data.url); // 最后插入图片
        }
      });
  },
};
// 修改 uploadVideo 菜单配置
editorConfig.MENU_CONF["uploadVideo"] = {
  // 自定义上传
  async customUpload(file, insertFn) {
    let mediaFile = file;
    //获取签名
    axios
      .get("https://yun-new-admin-api.yunicu.com/v3/getUgcUploadSign")
      .then((res) => {
        if (res.data.code === 0) {
          const getSignature = () => {
            return res.data.data.signature;
          };
          const tcVod = new TcVod({
            getSignature: getSignature, //上传签名的函数
          });
          const uploader = tcVod.upload({
            mediaFile: mediaFile, // 媒体文件（视频或音频或图片），类型为 File
          });
          uploader.done().then((res) => {
            insertFn(res.video.url); // 进行视频处理：转码和截图
          });
        }
      });
  },
};
// 图片变链接
import { update } from "../utils/update";
import {
  get_signature,get_videoLink
} from "../service/MedicalConference_y";


const data = [];
for (let i = 0; i < 100; i++) {
  data.push({
    key: i.toString(),
    name: `Edrward ${i}`,
    age: 32,
    address: `London Park no. ${i}`,
  });
}

export default {
  components: { Editor, Toolbar },
  data() {
    this.cacheData = data.map(item => ({ ...item }));
    return {
      data,
      columns,
      editingKey: '',
      editorConfig,
      editor: null,
      //    settingEditor: null,
      //    settingHtml:'',
      toolbarConfig: {},
      addShow: false,
      options: [
        { label: 'Option 1', value: 'option1' },
        { label: 'Option 2', value: 'option2' },
        { label: 'Option 3', value: 'option3' },
      ],
      form: {
        images: [],
        videos: [],
        introduce: '',
      },
      selectedOption: undefined,
      disabledVideo: false, 
      vFile: '',
      signature: '',
      mode: "default", // or 'simple'
    };
  },
  created() {
    // this.signature = get_signature()
    this.addShow = true
  },
  methods: {
    // 处理输入框值改变事件(输入框赋值)
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.find(item => key === item.key);
      if (target) { //就找到这个选项呗
        target[column] = value;
        this.data = newData;
      }
    },
    editTable(key) {
      const newData = [...this.data];
      const target = newData.find(item => key === item.key);
      this.editingKey = key;
      // console.log("怎么会是一行呢",this.editingKey)
      // console.log(target)
      if (target) {
        target.editable = true;
        this.data = newData;
      }
    },
    save(key) {
      const newData = [...this.data];
      const newCacheData = [...this.cacheData];
      // console.log("newCacheData",newData)
      const target = newData.find(item => key === item.key);
      const targetCache = newCacheData.find(item => key === item.key);
      if (target && targetCache) {
        delete target.editable;
        this.data = newData;
        Object.assign(targetCache, target);
        this.cacheData = newCacheData;
      }
      this.editingKey = '';
    },
    cancel(key) {
      const newData = [...this.data];
      const target = newData.find(item => key === item.key);
      this.editingKey = '';
      if (target) {
        Object.assign(target, this.cacheData.find(item => key === item.key));
        delete target.editable;
        this.data = newData;
      }
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    handlePaste(event) {
      // 阻止默认粘贴事件
      event.preventDefault();

      // 获取粘贴的内容
      const pastedText = (event.clipboardData || window.clipboardData).getData('text');

      // 在这里你可以自定义处理粘贴的内容，例如过滤、验证等操作
      // 然后将处理后的内容设置为选择框的值
      this.selectedOption = pastedText;
    },
    openVideoUrl(url){
      window.open(url)
    },
    //上传图片
    async uploadImg(type) {
      var inputTest = document.querySelector('#inputTest')
      let inputDOM = this.$refs[type].files[0];
      console.log("图片",this.$refs[type].files[0])
      if(inputDOM.size < 512000 ){
        const image = await update(inputDOM)
        if (image.code === 0 && this.form.images.length < 9 ){
          switch (type){
            case 'addImg':
              this.form.images.push(image.data.url)
              break;
          }
          this.$message.success('上传成功')
        }
        else {
          this.$message.warning('最多只能上传9张图片')
        }
      }
      else{
        this.$message.warning('仅上传500k内图片')
      }
      inputTest.value =''
    },
    // 上传视频
    async content_surface_plot_original_video(e) {
      if (e.currentTarget.files[0]) { // 选择了文件
        if (e.currentTarget.files[0].type === 'video/mp4') {
          this.vFile = e.currentTarget.files[0] // 获取上传文件中的File对象信息
          // console.log("视频",this.vFile) 
          await this.content_surface_plot_getSignature()
          await this.uploadVideoFile_toyun()
        } else {
          this.$message.warning('仅支持mp4格式的视频上传')
        }
      }
      else { // 取消选择文件
        this.vFile = {}
        this.vIsFileExist = false
      }
      document.getElementById('up_video_surface_plot').value = null;
    },
    //获取签名
    async content_surface_plot_getSignature() {
      this.disabledVideo = true
      const response = await get_signature()  // 获取签名
      if (response.code === 0) {
        this.signature = response.data.signature;
        // console.log("看看签名",this.signature)
      }
    },
    // 上传腾讯云 
    uploadVideoFile_toyun() {
      this.disabledVideo = true
      let _this = this
      const getSignature = () => {
        return _this.signature;  //签名
      }
      const tcVod = new _this.$TcVod({  //这是什么函数
        getSignature: getSignature // 前面的获取上传签名的函数
      })
      // console.log( tcVod)
      const mediaFile = this.vFile
      this.vUploader = tcVod.upload({  // 用签名上传视频
        mediaFile: mediaFile, // 媒体文件（视频或音频或图片），类型为 File
      })
      this.vUploader.done().then(res => { // 上传完成回调  √
        //视频上传后获取到的视频fileId
        this.yunVideo_fileId = res.fileId
        console.log('上传完成回调',res.fileId)
        //获取视频url地址
        this.content_video_url(res.fileId)  //其实就只是需要签名和文件然后传res.fileId调用接口获取视频url
        this.$message.success('视频文件上传成功')
      })
    },
    // 获取视频url地址
    async content_video_url(videoId) {
      this.disabledVideo = true
      const response = await get_videoLink(videoId)
      if (response.code === 0) {
        // this.form.video = response.data.mediaUrl
        this.form.videos.push(response.data.mediaUrl)
        let audio = new Audio(response.data.mediaUrl)
        let self = this
        audio.addEventListener("loadedmetadata",function (e){
          self.duration = parseInt(audio.duration)
        })
      }
      else {
        this.$message.warning(response.message)
      }
      this.disabledVideo = false
    },
  }
};
</script>


<style>
  .uploadImg{
    width: 100%;
    border: #DDDDDD 2px dashed;
    width: 120px;
    height: 120px;
    background-image: url("../assets/add.png");
    background-size:100% 100%;
    background-repeat:no-repeat;
    cursor: pointer;
    margin-right: 11px;
  
    /* 需要撤回就删 */
    float: left;   
    display: inline-block;
  }
  .upload_gutter{
    display: inline-block;
    padding-bottom: 10px;
  }
  .uploadImgVideo{
    border: #DDDDDD 2px dashed;
    width: 120px;
    height: 120px;
    background-image: url("../assets/add.png");
    background-size:100% 100%;
    background-repeat:no-repeat;
    cursor: pointer;
    float: left;  
    margin-right: 12px;
  }
  .editable-row-operations a {
    margin-right: 8px;
  }
  .testGrid{
    width:100px;
    height: 100px;
    background-color: #cfb6b6;
    display: grid;
    place-items:center
  }
</style>
